<template>
  <div class="container py-10">
    <div class="flex flex-wrap -mx-10">
      <div v-if="computedSubmissionDetails.revisedProjectInfo" class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Project Details</h2>
        <edit-project-info v-if="computedSubmissionDetails.revisedProjectInfo" class="mb-3" :project.sync="computedSubmissionDetails.revisedProjectInfo" />
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Additional Project Details</h2>
        <div v-if="computedRevisionProjectInfo">
          <d-field label="Status">
            <d-input v-model="computedRevisionProjectInfo.status" aria-label="Status" />
          </d-field>
        </div>

        <h2 class="mt-10">
          Submittor Details
        </h2>
        <d-field label="Submitted By">
          <d-input v-model="computedSubmissionDetails.revisedSubmitterName" />
        </d-field>
        <d-field label="Submitted By">
          <d-input v-model="computedSubmissionDetails.revisedSubmitterEmail" type="email" />
        </d-field>
        <d-field label="Project Role">
          <d-input v-model="computedSubmissionDetails.revisedSubmitterProjectRole" />
        </d-field>
      </div>
    </div>

    <div class="flex flex-wrap -mx-10">
      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Design Firm Details</h2>
        <div v-if="computedRevisionFirm">
          <d-field label="Firm Name">
            <d-input v-model="computedRevisionFirm.name" />
          </d-field>
          <d-field label="Firm Email">
            <d-input v-model="computedRevisionFirm.email" />
          </d-field>
          <d-field label="Address Line 1">
            <d-input v-model="computedRevisionFirm.addressLine1" />
          </d-field>
          <d-field label="Address Line 2">
            <d-input v-model="computedRevisionFirm.addressLine2" />
          </d-field>
          <d-field label="City">
            <d-input v-model="computedRevisionFirm.city" />
          </d-field>
          <d-field label="State/Province">
            <d-input v-model="computedRevisionFirm.state" />
          </d-field>
          <d-field label="Zip/Postal">
            <d-input v-model="computedRevisionFirm.zip" />
          </d-field>
          <d-field label="Firm Phone Number">
            <d-input v-model="computedRevisionFirm.phone" />
          </d-field>
          <d-field label="Firm Fax">
            <d-input v-model="computedRevisionFirm.fax" />
          </d-field>
          <d-field>
            <d-switch v-model="computedSubmissionDetails.revisedSendCredentialsToFirm">
              Send QCP participant credentials to Design Firm?
            </d-switch>
          </d-field>
        </div>
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Design Firm Contact Details</h2>
        <div v-if="computedRevisionFirmContact">
          <d-field label="First Name">
            <d-input v-model="computedRevisionFirmContact.firstName" />
          </d-field>
          <d-field label="Last Name">
            <d-input v-model="computedRevisionFirmContact.lastName" />
          </d-field>
          <d-field label="Organization Name">
            <d-input v-model="computedRevisionFirmContact.organizationName" />
          </d-field>
          <d-field label="Email">
            <d-input v-model="computedRevisionFirmContact.email" />
          </d-field>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap -mx-10">
      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Contractor Details</h2>
        <div v-if="computedRevisionContractor">
          <d-field label="Contractor Organization Name">
            <d-input v-model="computedRevisionContractor.name" />
          </d-field>
          <d-field label="Contractor Organization Email">
            <d-input v-model="computedRevisionContractor.email" />
          </d-field>
          <d-field label="Address Line 1">
            <d-input v-model="computedRevisionContractor.addressLine1" />
          </d-field>
          <d-field label="Address Line 2">
            <d-input v-model="computedRevisionContractor.addressLine2" />
          </d-field>
          <d-field label="City">
            <d-input v-model="computedRevisionContractor.city" />
          </d-field>
          <d-field label="State/Province">
            <d-input v-model="computedRevisionContractor.state" />
          </d-field>
          <d-field label="Zip/Postal">
            <d-input v-model="computedRevisionContractor.zip" />
          </d-field>
          <d-field label="Contractor Organization Phone Number">
            <d-input v-model="computedRevisionContractor.phone" />
          </d-field>
          <d-field label="Contractor Organization Fax">
            <d-input v-model="computedRevisionContractor.fax" />
          </d-field>
          <d-field>
            <d-switch v-model="computedSubmissionDetails.sendCredentialsToContractor">
              Send QCP participant credentials to Contractor?
            </d-switch>
          </d-field>
        </div>
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Contractor Contact Details</h2>
        <div v-if="computedRevisionContractorContact">
          <d-field label="First Name">
            <d-input v-model="computedRevisionContractorContact.firstName" />
          </d-field>
          <d-field label="Last Name">
            <d-input v-model="computedRevisionContractorContact.lastName" />
          </d-field>
          <d-field label="Organization Name">
            <d-input v-model="computedRevisionContractorContact.organizationName" />
          </d-field>
          <d-field label="Email">
            <d-input v-model="computedRevisionContractorContact.email" />
          </d-field>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap -mx-10">
      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Woodworker Details</h2>
        <div v-if="computedRevisionWoodworker">
          <d-field label="Woodworker Organization Name">
            <d-input v-model="computedRevisionWoodworker.name" />
          </d-field>
          <d-field label="Woodworker Organization Email">
            <d-input v-model="computedRevisionWoodworker.email" />
          </d-field>
          <d-field label="Address Line 1">
            <d-input v-model="computedRevisionWoodworker.addressLine1" />
          </d-field>
          <d-field label="Address Line 2">
            <d-input v-model="computedRevisionWoodworker.addressLine2" />
          </d-field>
          <d-field label="City">
            <d-input v-model="computedRevisionWoodworker.city" />
          </d-field>
          <d-field label="State/Province">
            <d-input v-model="computedRevisionWoodworker.state" />
          </d-field>
          <d-field label="Zip/Postal">
            <d-input v-model="computedRevisionWoodworker.zip" />
          </d-field>
          <d-field label="Woodworker Organization Phone Number">
            <d-input v-model="computedRevisionWoodworker.phone" />
          </d-field>
          <d-field label="Woodworker Organization Fax">
            <d-input v-model="computedRevisionWoodworker.fax" />
          </d-field>
          <d-field>
            <d-switch v-model="computedSubmissionDetails.sendCredentialsToWoodworker">
              Send QCP participant credentials to Woodworker?
            </d-switch>
          </d-field>
        </div>
      </div>

      <div class="mb-16 w-full lg:w-1/2 px-10">
        <h2>Woodworker Contact Details</h2>
        <div v-if="computedRevisionWoodworkerContact">
          <d-field label="First Name">
            <d-input v-model="computedRevisionWoodworkerContact.firstName" />
          </d-field>
          <d-field label="Last Name">
            <d-input v-model="computedRevisionWoodworkerContact.lastName" />
          </d-field>
          <d-field label="Organization Name">
            <d-input v-model="computedRevisionWoodworkerContact.organizationName" />
          </d-field>
          <d-field label="Email">
            <d-input v-model="computedRevisionWoodworkerContact.email" />
          </d-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import EditProjectInfo from '@resources/scripts/patterns/formPatterns/EditProjectInfo.vue';

  export default {
    components: {
      EditProjectInfo,
    },

    props: {
      submissionDetails: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      computedSubmissionDetails: {
        get() {
          return this.submissionDetails;
        },
        set(value) {
          this.$emit('update:submissionDetails', value);
        },
      },

      computedRevisionProjectInfo() {
        return this.computedSubmissionDetails.revisedProjectInfo;
      },

      computedRevisionFirm() {
        return this.computedSubmissionDetails.revisedFirm;
      },

      computedRevisionFirmContact() {
        return this.computedSubmissionDetails.revisedFirmContact;
      },

      computedRevisionContractor() {
        return this.computedSubmissionDetails.revisedContractor;
      },

      computedRevisionContractorContact() {
        return this.computedSubmissionDetails.revisedContractorContact;
      },

      computedRevisionWoodworker() {
        return this.computedSubmissionDetails.revisedWoodworker;
      },

      computedRevisionWoodworkerContact() {
        return this.computedSubmissionDetails.revisedWoodworkerContact;
      },
    },
  };
</script>